import React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const styles = theme => ({
  stepperWrapper: {
  }
});

class Progress extends React.Component {
  getSteps = () => {
    const { application } = this.props;

    if (application.status === 'unauthorized') {
      return ['lodged', 'unauthorized'];
    }
    return ['lodged', 'authorized', 'doc_requested', 'quoted', 'approved', 'complete'];
  }

  render = () => {
    const { application, classes } = this.props;

    return (
      <Stepper
        className={classes.stepperWrapper}
        activeStep={this.getSteps().indexOf(application.status) + 1}
      >
        <Step key="application">
          <StepLabel>
            <Link to={`/applications/${application.number}`}>
              {application.number}
            </Link>
          </StepLabel>
        </Step>
        {this.getSteps().map((label, index) => {
          const props = {};
          const labelProps = {};
          return (
            <Step key={label} {...props}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    );
  };
}

const styled = withStyles(styles)(Progress);
export default styled;



// WEBPACK FOOTER //
// ./src/components/Applications/Progress.js